import Constant from "./Constant";

export const getPreloadedTaskIds = (machine) => {
    return (machine.tasks || []).filter(task => task.status === Constant.TASK_STATUS_PRELOADED).map(task => task.id)
}

// Le worker a pris la demande dès qu'une tâche passe en cours (2) ou en impression (6), ou qu'un préchargé présent
// à l'appui change de statut. Une tâche qui arrive, est supprimée ou déplacée ne prouve rien : le message peut encore attendre.
export const isRequestPickedUp = (machine, request) => {
    const tasks = machine.tasks || []

    if (tasks.some(task => [Constant.TASK_STATUS_IN_PROGRESS, Constant.TASK_STATUS_PRINTING].includes(task.status))) {
        return true
    }

    return request.preloadedTaskIds.some(taskId => {
        return !tasks.some(task => task.id === taskId && task.status === Constant.TASK_STATUS_PRELOADED)
    })
}
